import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import '../../global.css';
import NeuralCanvas from '../../components/NeuralCanvas';
import GoogleButton from '../../components/GoogleButton';
import WordmarkLogo from '../../components/WordmarkLogo';
import AuthFooter from '../../components/AuthFooter';
import { loginUser, socialAuth, clearError } from '../../store/slices/authSlice';

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { loading, error, accessToken, requiresVerification } = useSelector(s => s.auth);
  const [form, setForm] = useState({ email: '', password: '' });

  const from = location.state?.from?.pathname || '/dashboard';

  useEffect(() => {
    dispatch(clearError());
  }, [dispatch]);
  useEffect(() => {
    if (!accessToken) return;
    if (requiresVerification) navigate('/verify-email');
    else navigate(from, { replace: true });
  }, [accessToken, requiresVerification, navigate, from]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser({ email: form.email, password: form.password }));
  };

  return (
    <div className="auth-layout">
      <NeuralCanvas />

      <div className="signup-shell">
      <div className="signup-left">
        <WordmarkLogo size={22} />
        <div style={{ margin: 'auto 0', display: 'flex', flexDirection: 'column', gap: 32, maxWidth: 440 }}>
          <div className="dash-sub">AI FOR AFRICA</div>
          <h1 className="signup-title">Built for<br /><em>Africa's story.</em></h1>
          <p className="signup-sub">Technology that understands your language, your challenges, and your people — for businesses, hospitals, farms, and builders shaping the continent.</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14, paddingTop: 28, borderTop: '1px solid var(--line)' }}>
            {[
              ['1.4B', 'people across Africa we are building for'],
              ['18', 'African languages — spoken, not just translated'],
              ['6', 'industries: health, agri, finance, safety & more'],
            ].map(([n, l]) => (
              <div key={n} style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: 22, fontWeight: 500, color: 'var(--fg)', letterSpacing: '-0.03em', minWidth: 72 }}>{n}</div>
                <div style={{ fontSize: 13, color: 'var(--fg-dim)' }}>{l}</div>
              </div>
            ))}
          </div>
        </div>

      </div>

      <div className="signup-right">
        <form className="signup-form" onSubmit={handleSubmit}>
          <div>
            <div className="dash-sub" style={{ marginBottom: 10 }}>SIGN IN</div>
            <h2 className="signup-title" style={{ fontSize: 30 }}>Welcome back.</h2>
          </div>

          {error && (
            <div className="alert alert-error">
              <span>{error}</span>
              <button className="alert-dismiss" onClick={() => dispatch(clearError())} aria-label="Dismiss">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 2l8 8M10 2l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
              </button>
            </div>
          )}

          <GoogleButton
            label="Continue with Google"
            onSuccess={(profile) => dispatch(socialAuth({ provider: 'google', ...profile }))}
          />

          <div className="auth-divider">or</div>

          <div className="field">
            <label>Email</label>
            <input type="email" required placeholder="you@company.com"
              value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className="field">
            <label>Password</label>
            <input type="password" required placeholder="••••••••••••"
              value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
          </div>

          <button type="submit" className="btn btn-primary btn-lg" style={{ justifyContent: 'center' }} disabled={loading}>
            {loading ? <span className="btn-loader" /> : null}
            {loading ? 'Signing in…' : 'Sign in'}
          </button>

          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12 }}>
            <Link to="/forgot-password" style={{ color: 'var(--fg-mid)' }}>Forgot password?</Link>
            <Link to="/signup" style={{ color: 'var(--accent)' }}>Create account →</Link>
          </div>
        </form>
      </div>
      </div>

      <AuthFooter />
    </div>
  );
}
